module.exports = __webpack_public_path__ + "img/case3-3.21c7f732.png";